import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService,private toastService: ToastrService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isLoggedIn = !!(localStorage.getItem('bearerToken') || sessionStorage.getItem('bearerToken')); // Check if the user is logged in
    if (isLoggedIn) {
      let claimType: string = next.data["claimType"];
      if (claimType) {
        if (!this.authService.hasClaim(claimType)) {
          // If the user does not have the required claim, redirect to a specific page
          //this.toastService.showToast('You donot have access to this page!!', 'Error');
         this.router.navigate(['/404']);
          return false;
        }
      }
      // If the user is logged in and has the required claim (if specified), allow access
      return true;
    } else {
      // If the user is not logged in, redirect to the sign-in page
      this.router.navigate(['/auth/sign-in']);
      return false;
    }
  }
}
